const HEAD_IDX = 0;

/**
 * Get first element from array
 * @export
 * @param {Array} arr array
 * @returns {any} first element
 */
export default function head(arr) {
   return arr[HEAD_IDX];
}
